import EmailVerification from './EmailVerification.page';

export default EmailVerification;